import { roleLabelMap } from "./roleLabel";


export function getRoleLabel(userRoles: string[] = []): string {

  const priority = [
    "ADMIN",
    "PROCTOR",
    "FRONT_DESK",
    "EXAMINER_RWO",
    "EXAMINER_ITWO",
    "EXAMINER_HWOA",
    "EXAMINER_HRWOB",
    "EXAMINER_HRWOC",
    "EXAMINER_HRWOD",
    "EXAMINER_DWO",
    "EXAMINER_AWO",
    "HRWO",
  ];

  for (const role of priority) {
    if (userRoles.includes(role)) {
      return roleLabelMap[role];
    }
  }

  // Fallback to first matching known role
  for (const role of userRoles) {
    if (roleLabelMap[role]) {
      return roleLabelMap[role];
    }
  }

  return ""; // Unknown role or no label
}
